// src/components/DemoForm.js
import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./DemoForm.css";

const DemoForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    position: "",
    company: "",
    challenges: "",
    issues: "",
    objectives: "",
    features: [],
    integrations: "",
    scale: "",
    additional: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        features: checked
          ? [...prev.features, value]
          : prev.features.filter((item) => item !== value),
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        {
          ...formData,
          features: formData.features.join(", "),
        },
        "YOUR_PUBLIC_KEY"
      )
      .then(
        () => {
          alert("Form submitted successfully!");
        },
        (error) => {
          console.error(error);
          alert("Failed to submit form.");
        }
      );
  };

  return (
    <form className="demo-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <input name="firstName" placeholder="First name" onChange={handleChange} required />
        <input name="lastName" placeholder="Last name" onChange={handleChange} required />
      </div>

      <div className="form-row">
        <input name="email" type="email" placeholder="Email" onChange={handleChange} required />
        <input name="phone" placeholder="Phone" onChange={handleChange} />
      </div>

      <input name="address" placeholder="Address" onChange={handleChange} />
      <input name="position" placeholder="Position" onChange={handleChange} />
      <input name="company" placeholder="Company name" onChange={handleChange} />

      <textarea
        name="challenges"
        placeholder="What specific operational challenges are you currently facing in your environments?"
        onChange={handleChange}
      />

      <textarea
        name="issues"
        placeholder="Can you describe the types of issues you encounter?"
        onChange={handleChange}
      />

      <textarea
        name="objectives"
        placeholder="What primary objectives do you aim to achieve by adopting a computer vision solution?"
        onChange={handleChange}
      />

      <div className="checkbox-group">
        <p>Which features of our platform do you find most appealing?</p>

        {[
          "Defect detection",
          "Quality Control System",
          "Data Analytics and Reporting",
          "User Role Management",
          "Performance Tracking",
          "Predictive Maintenance",
          "Other",
        ].map((feature) => (
          <label key={feature}>
            <input
              type="checkbox"
              value={feature}
              onChange={handleChange}
            />
            {feature}
          </label>
        ))}
      </div>

      <textarea
        name="integrations"
        placeholder="What existing technologies or systems do you currently utilize, and how do you envision integrating them with our platform?"
        onChange={handleChange}
      />

      <div className="radio-group">
        <p>What is the scale of your operations?</p>

        {["Small scale", "Mid Size", "Large Enterprise"].map((size) => (
          <label key={size}>
            <input
              type="radio"
              name="scale"
              value={size}
              onChange={handleChange}
            />
            {size}
          </label>
        ))}
      </div>

      <textarea
        name="additional"
        placeholder="Is there anything else you would like to share regarding your needs or expectations from our platform?"
        onChange={handleChange}
      />

      <button type="submit" className="submit-btn">Submit</button>
    </form>
  );
};

export default DemoForm;
